import { IRichTextInformation } from "@bond-london/graphcms-rich-text";
import classNames from "classnames";
import React from "react";
import { RTF } from "../elements/RTF";
import { Separator } from "../elements/Separator";
import { lookupColourString } from "../lookups";
import {
  MainWidthClassName,
  P3AllRTFOverrides,
  SecondaryWidthClassName,
  SectionPaddingClassName,
} from "../styles";

export const BodyText: React.FC<{
  body?: IRichTextInformation;
  backgroundColour?: Queries.GraphCMS_Colour | null;
  typeIndex: number;
}> = ({ body, backgroundColour, typeIndex }) => {
  if (!body) return null;
  return (
    <section
      data-component="Body Text"
      className={classNames(
        lookupColourString(backgroundColour, "bg"),
        lookupColourString(backgroundColour, "textForBg"),
        "page-grid max-width relative",
        SectionPaddingClassName,
        "md:gap-y-40px",
      )}
    >
      {typeIndex === 0 && (
        <Separator
          className={classNames(MainWidthClassName, "hidden md:block")}
        />
      )}
      <RTF
        content={body}
        classNameOverrides={P3AllRTFOverrides}
        className={classNames("space-y-20px", SecondaryWidthClassName)}
      />
    </section>
  );
};
